module.exports = __webpack_public_path__ + "static/media/ImgNovedades220906_1.5df37b0e.jpg";